import { Box } from '@mui/material';
import React from 'react';
import NavBar from '../../components/navbar/navbar';
import { AgreementsTypes } from './types';
import { useLocation, useNavigate } from 'react-router-dom';
import { agreements } from '../../utils/data';
import HomeCard from '../../components/homecard/homecard';

const ListByAgreement: React.FC = () => {
    const [agreementType, setAgreementType] = React.useState<AgreementsTypes| undefined>(undefined);
    const location = useLocation();
    const navigate = useNavigate();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    };

    const renderAgreements = () => {
        if(agreementType){
            return agreements[agreementType].map((item) => (
                <HomeCard data={item} handleClick={handleCardClick}/>
            ));
        }
        return '';
    };

    React.useEffect(() => {
        if(location.state?.agreement){
            setAgreementType(location.state.agreement);
        } else {
            navigate('/')
        }
    }, [location, navigate]);

    return (
        <Box>
            <NavBar active="servicios"/>
            <Box m={5}>
                {renderAgreements()}
            </Box>
        </Box>
    );
};

export default ListByAgreement;